export const docType = [
  {
    name: "FICHA DE EPI",
    value: "ficha_epi",
  },
  {
    name: "ASO - ADMISSIONAL",
    value: "admissional",
  },
  {
    name: "ASO - PERIÓDICO",
    value: "periodico",
  },
  {
    name: "ASO - RETORNO AO TRABALHO",
    value: "retorno_ao_trabalho",
  },
  {
    name: "ASO - MUDANÇA DE RISCO",
    value: "mudança_de_risco",
  },
  {
    name: "ASO - MONITORAÇÃO PONTUAL",
    value: "monitoracao_pontual",
  },
  {
    name: "ASO - DEMISSIONAL",
    value: "demissional",
  },

  {
    name: "CERTIFICADO",
    value: "certificado",
  },
  {
    name: "OUTROS DOCUMENTOS",
    value: "docs",
  },

  {
    name: "NÃO INFORMADO",
    value: "nao_informado",
  },
];

export const afastamentoType = [
  {
    name: "NÃO INFORMADO",
    value: "não informado",
  },
  {
    name: "TRAJETO",
    value: "não informado",
  },
  {
    name: "ATROPELAMENTO",
    value: "atropelamento",
  },
  {
    name: "COLISÃO",
    value: "colisão",
  },
  {
    name: "LICENÇA",
    value: "license",
  },
  {
    name: "FÉRIAS",
    value: "ferias",
  },
  {
    name: "OUTROS",
    value: "outros",
  },
];

// class Lookups {
//   addCurrentValue (value) {
//     const currentPeriod = {
//       label: `Periodo atual: ${value} dias`,
//       value: Number(value)
//     }
//     periodicityField[6] = currentPeriod

//     return periodicityField
//   }
// }

export default { docType, afastamentoType };
